import React from 'react'
import { Link } from 'react-router-dom'
import servicesTwoData from './servicesTwoData'

const ServicesTwo = () => {
    return (
        <section className="our-service-wrapper section-padding bg-gray">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="block-contents text-center">
                            <div className="section-title">
                                <h5>Service</h5>
                                <span>Featured Service</span>
                                <h2>What We Do</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4">
                    {
                        servicesTwoData.map((data) => (
                            <div className="col-xl-3 col-md-6 col-12 d-flex" key={data.id}>
                                <div className="single-service-card w-100">
                                    <div className="service-cover-img bg-cover" style={{ backgroundImage: `url(${data.img})` }}></div>
                                    <div className="content">
                                        <div className="icon-title">

                                            <div className="service-title">
                                                <h4>{data.title}</h4>
                                            </div>
                                        </div>
                                        <p>{data.desc}</p>
                                        <a href="https://wa.me/971502033924" target="_blank" rel="noopener noreferrer" className="read-more mt-auto">Get Quotes <i className="fal fa-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                </div>
            </div>
        </section>
    )
}

export default ServicesTwo